import { createContext, useContext, useEffect, useState } from "react";
import Loader from "../components/ui/loader";
import { useNavigate } from "react-router-dom";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null); // holds user data
  const [loading, setLoading] = useState(true); // used to prevent flashing
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    checkAuth();
  }, [])


  const checkAuth = async () => {
    try {
      const res = await fetch(`${API_URL}/user`, {
        credentials: "include",
        headers:{
          "Cache-Control":"no-cache",
        },
      });

      if (res.status === 401 || res.status === 403) {
        // Session expired or unauthorized        
        setUser(null);
        // window.location.href('/login') //force logout
        return;
      }

      if (res.status === 304) {
        // Not modified → keep existing user
        return;
      }
      const data = await res.json();
      setUser(data.user);
    } catch (err) {
      console.error("Failed to fetch user:", err);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    try {
      const response = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
        credentials:"include",

      })

      const data = await response.json();
      const status = response.status;
      const exceptionMessage = status === 401 ? 'Login failed. Check credentials' :
      'Server error. Please try again later'; 
     
      if (response.ok) {
        setUser(data.user);
        setLoading(false);
        
        // // ensure context + cookie are in sync
        // await checkAuth();

        return {
          success: true,
          message: 'Login Successful',
          user: data.user
        };
      } else {
        //exceptions - 401,500
        return {
          success: false,
          message: data.message
        }
      }
    } catch (error) {
      return {
        success: false,
        message: 'Something went wrong while trying to login. Try again later.'
      }

    }
  }

  // if (!user) {
  //   return <Loader />
  // }

  return (
    <AuthContext.Provider value={{ user, login, checkAuth, setUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);